import * as toDesktopClientFs from '@todesktop/client-fs';
import { APP_DATA_FOLDER } from '../constants';
import { isDesktopApp } from '@todesktop/client-core/platform/todesktop';
import { captureException } from '@fabric-app/compat/capabilities/sentry';
import { app } from '@todesktop/client-core';

export const getLocalFileSyncTenantId = async () => {
  if (!isDesktopApp() || !toDesktopClientFs || !toDesktopClientFs.stat) {
    return null;
  }

  if (typeof toDesktopClientFs === 'undefined') {
    captureException(new Error('@todesktop/client-fs is undefined'), {
      extra: {
        desktopVersion: app.getVersion(),
      },
    });
    return null;
  }

  const stats = await toDesktopClientFs.stat(APP_DATA_FOLDER, '/');
  return String(stats.dev);
};
